import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "../../css/ShowRoom.css";

const CommercialSelectionComponent = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const [clickDelay, setClickDelay] = useState(null); // Track the timeout delay
  const sliderRef = useRef(null); // Reference to the slider instance
  const sliderContainerRef = useRef(null); // Reference to the slider container

  const isMouseInside = useRef(false); // Track if the mouse is inside the slider

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: true,
    focusOnSelect: true,

    beforeChange: (current, next) => {
      setPrevIndex(current);
      setCurrentIndex(next);
    },

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Determine the number of levels based on the current path
  const getBasePath = () => {
    const depth = window.location.pathname.split("/").length - 1;
    return "../".repeat(depth - 1); // Adjust `-1` based on your specific project structure
  };

  const basePath = getBasePath();

  const slides = [
    {
      id: 1,
      title: "MAGELLAN RESTAURANT",
      description:
        "A sophisticated blend of modern design, cascading greenery, and luxurious details, creating an elegant dining experience",
      image: `${basePath}Images/CommercialImages/MagellanRestaurant.jpg`,
      link: "/interior-design/commercial/magellan-restaurant",
    },
    {
      id: 2,
      title: "RADISSON BLUE",
      description: "Where Luxury Meets Comfort and Elegance",
      image: `${basePath}Images/CommercialImages/radissonblue.jpg`,
      link: "/interior-design/commercial/radisson-blue",
    },
    {
      id: 3,
      title: "UNODC CENTRE",
      description:
        "Designing a forward-thinking space for innovation and collaboration at the UNODC Regional Centre in Lusail, Qatar.",
      image: `${basePath}Images/CommercialImages/unodcr.jpg`,
      link: "/interior-design/commercial/unodc-centre",
    },
    {
      id: 4,
      title: "TURKISH CONSULATE",
      description:
        "Diplomacy with a blend of elegance, functionality, and cultural harmony in the heart of Riyadh.",
      image: `${basePath}Images/CommercialImages/riyadhturkish.jpeg`,
      link: "/interior-design/commercial/riyadh-turkish",
    },
    {
      id: 5,
      title: "DAWLANCE OFFICE",
      description:
        "Blend modern design with functional sophistication, creating a space that reflects innovation and excellence",
      image: `${basePath}Images/CommercialImages/dawlance.jpg`,
      link: "/interior-design/commercial/dawlance-office",
    },
    {
      id: 6,
      title: "UMMBAB TOWER",
      description:
        "A modern and sustainable high-rise with panoramic views and architectural brilliance.",
      image: `${basePath}Images/CommercialImages/ummbab.png`,
      link: "/interior-design/commercial/ummbab-tower",
    },
    {
      id: 7,
      title: "SADKO BAKU",
      description:
        "An innovative space blending modern aesthetics with luxurious comfort in Baku.",
      image: `${basePath}Images/CommercialImages/sadkobaku.jpg`,
      link: "/interior-design/commercial/sadko-baku",
    },
    {
      id: 8,
      title: "WOOD ATELIER",
      description:
        "A creative space that celebrates the warmth and craftsmanship of wood in interior design.",
      image: `${basePath}Images/CommercialImages/woodatelier.jpg`,
      link: "/interior-design/commercial/wood-atelier",
    },
    {
      id: 9,
      title: "MARRIOTT RESIDENCE",
      description:
        "A luxurious and modern residence offering comfort and elegance at the Marriott.",
      image: `${basePath}Images/CommercialImages/mariott.png`,
      link: "/interior-design/commercial/marriott-residence",
    },
    {
      id: 10,
      title: "ROMATEM MOVE",
      description:
        "Innovative office design blending functionality with movement for an inspiring work environment.",
      image: `${basePath}Images/CommercialImages/romatemmove.png`,
      link: "/interior-design/commercial/romatem-move",
    },
    {
      id: 11,
      title: "AZEL LAW",
      description:
        "A professional office design combining elegance with modern legal aesthetics.",
      image: `${basePath}Images/CommercialImages/azellawoffice.jpg`,
      link: "/interior-design/commercial/azel-law",
    },
    {
      id: 12,
      title: "WANDER CHOCOLATE",
      description:
        "A delightful chocolate shop with a design focused on warmth and indulgence.",
      image: `${basePath}Images/CommercialImages/wanderchocolate.jpg`,
      link: "/interior-design/commercial/wander-chocolate",
    },
    {
      id: 13,
      title: "FARM HOUSE",
      description:
        "Rustic and charming farmhouse design that emphasizes simplicity and natural beauty.",
      image: `${basePath}Images/CommercialImages/farmhousestore.jpg`,
      link: "/interior-design/commercial/farm-house",
    },
    {
      id: 14,
      title: "MINIMALIST CONCEPT",
      description:
        "A clean, clutter-free interior design focusing on the beauty of simplicity.",
      image: `${basePath}Images/CommercialImages/minimalistoffice.jpg`,
      link: "/interior-design/commercial/minimalist-concept",
    },
    {
      id: 15,
      title: "HAIR CLINIC",
      description:
        "A modern and calming space designed for a cutting-edge hair clinic experience.",
      image: `${basePath}Images/CommercialImages/hairclinic.jpg`,
      link: "/interior-design/commercial/hair-clinic",
    },
  ];

  // Handle the smooth transition timing for description
  useEffect(() => {
    if (prevIndex !== null) {
      const timeout = setTimeout(() => {
        setPrevIndex(null); // Reset the previous index after transition
      }, 800); // Matches the transition duration in CSS (0.8s)
      return () => clearTimeout(timeout);
    }
  }, [prevIndex]);

  const handleMouseDown = () => {
    setClickDelay(
      setTimeout(() => {
        setClickDelay(null);
      }, 200)
    );
  };

  const handleClick = (link) => {
    if (clickDelay) {
      if (link) {
        window.location.href = link; // Navigate to the link
      }
    }
  };

  // Scroll and arrow key navigation
  useEffect(() => {
    const handleWheel = (event) => {
      if (isMouseInside.current && sliderRef.current) {
        event.preventDefault(); // Prevent page scroll
        if (event.deltaY > 0) {
          sliderRef.current.slickNext();
        } else {
          sliderRef.current.slickPrev();
        }
      }
    };

    // Only add the event listener when mouse is inside slider container
    const sliderContainer = sliderContainerRef.current;
    if (sliderContainer) {
      sliderContainer.addEventListener("wheel", handleWheel, {
        passive: false,
      });
    }

    // Function to handle arrow key navigation
    const handleKeyDown = (event) => {
      if (isMouseInside.current && sliderRef.current) {
        if (event.key === "ArrowRight") {
          sliderRef.current.slickNext(); // Right arrow key moves to next slide
        } else if (event.key === "ArrowLeft") {
          sliderRef.current.slickPrev(); // Left arrow key moves to previous slide
        }
      }
    };

    // Attach event listeners to the window
    if (sliderContainer) {
      window.addEventListener("wheel", handleWheel, { passive: false });
      window.addEventListener("keydown", handleKeyDown, { passive: false });
    }
    // Cleanup listeners on component unmount
    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Runs only once when the component mounts

  // Optional: Automatically focus the slider container on load
  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.innerSlider.list.focus();
    }
  }, []);

  return (
    <>
      <div
        className="slider-container"
        ref={sliderContainerRef}
        onMouseEnter={() => (isMouseInside.current = true)}
        onMouseLeave={() => (isMouseInside.current = false)}
      >
        {/* Image Container */}
        <div className="image-container">
          {slides.map((slide, index) => {
            let className = "main-image";
            if (index === currentIndex) {
              className += " active";
            } else if (index === prevIndex) {
              className += " outgoing";
            }

            return (
              <img
                key={slide.id}
                src={slide.image}
                alt={slide.title}
                className={`${className} ${
                  index === currentIndex && prevIndex !== null ? "incoming" : ""
                }`}
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundSize: "cover",
                  objectFit: "cover",
                }}
              />
            );
          })}
        </div>

        {/* Description text in a div */}
        <div
          className={`description-container ${
            prevIndex !== null ? "outgoing-text" : ""
          } ${currentIndex !== prevIndex ? "incoming-text" : ""} ${
            currentIndex === prevIndex ? "active-text" : ""
          }`}
        >
          <p className="description-text">{slides[currentIndex].description}</p>
        </div>

        {/* Titles Slider */}
        <Slider ref={sliderRef} {...sliderSettings} className="slider">
          {slides.map((slide, index) => (
            <div key={slide.id} className="slide">
              <div
                className={`slide-title ${
                  index === currentIndex ? "active-title" : ""
                }`}
                onMouseDown={handleMouseDown} // Start the delay on mouse down
                // Handle click after delay
                style={{
                  fontSize: "24px", // Bigger font
                  fontWeight: "bold",
                  textAlign: "center",
                  cursor: slide.link ? "pointer" : "default", // Show pointer if navigable
                }}
              >
                <p
                  onClick={() => handleClick(slide.link)}
                  style={{
                    fontSize: "50px",
                  }}
                >
                  {slide.title}
                </p>{" "}
                {/* Wrap title with <p> tag */}
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="slides-list">
        {slides.map((slide) => (
          <div
            key={slide.id}
            className="list-item"
            onClick={() => (window.location.href = slide.link)}
          >
            {slide.title}
          </div>
        ))}
      </div>
    </>
  );
};

export default CommercialSelectionComponent;
